import { useDispatch, useSelector } from "react-redux";
import { toggleProgressCell } from "../../../features/progressChart/progressChartSlice";
import {
    Section,
    Title,
    MainText,
    TableWrapper,
    TableHeaderRow,
    HeaderCell,
    LabelFull,
    LabelShort,
    TableRow,
    LessonCell,
    CellButton,
} from "./ProgressChartStyle";
import { myprogress } from "../../../i18n/04_myprogress";

const COLUMNS = [
    { key: "grammar", full: "Grammar", short: "G" },
    { key: "readingTexts", full: "Reading Texts", short: "RT" },
    { key: "readingSigns", full: "Reading Signs", short: "RS" },
    { key: "listening", full: "Listening", short: "L" },
    { key: "speakingDialogs", full: "Speaking Dialogs", short: "SD" },
    { key: "speakingStories", full: "Speaking Stories", short: "SS" },
];

const LESSONS = Array.from({ length: 30 }, (_, i) => i + 1);

const ProgressChart = () => {
    const lang = useSelector(state => state.lang.lang)
    const t = myprogress[lang]

    const dispatch = useDispatch();

    const { cells, loading, error } = useSelector((s) => s.progressChart);
    const role = useSelector((s) => s.auth?.user?.role);
    const selectedStudentId = useSelector((s) => s.teacher?.selectedStudentId);

    const canTeacherTick = role === "TEACHER" && !!selectedStudentId;
    const isStudentView = role === "STUDENT" || !role; // logged out also can’t tick


    const statusByKey = new Map(
        (cells || []).map((c) => [`${c.lessonNumber}|${c.columnKey}`, c.status ?? 0])
    );

    const getStatus = (lessonNumber, columnKey) =>
        statusByKey.get(`${lessonNumber}|${columnKey}`) ?? 0;

    const nextStatus = (s) => (s + 1) % 3;

    const handleToggle = (lessonNumber, columnKey) => {
        if (!canTeacherTick) return;
        const current = getStatus(lessonNumber, columnKey);
        dispatch(toggleProgressCell({ lessonNumber, columnKey, status: nextStatus(current) }));
    };


    return (
        <Section>
            <Title>{t.progressChartTitle}</Title>

            <MainText>
                {t.progressChartText}
            </MainText>

            {loading && <p>Loading progress chart...</p>}
            {error && <p style={{ color: "red" }}>{t.mustLogIn}</p>}

            <TableWrapper>
                <TableHeaderRow>
                    <HeaderCell>Lesson</HeaderCell>
                    {COLUMNS.map((col) => (
                        <HeaderCell key={col.key}>
                            <LabelFull>{col.full}</LabelFull>
                            <LabelShort>{col.short}</LabelShort>
                        </HeaderCell>
                    ))}
                </TableHeaderRow>

                {LESSONS.map((lessonNumber) => (
                    <TableRow key={lessonNumber}>
                        <LessonCell>Lesson {lessonNumber}</LessonCell>

                        {COLUMNS.map((col) => {
                            const status = getStatus(lessonNumber, col.key);
                            const disabled = !canTeacherTick;

                            return (
                                <CellButton
                                    key={`${lessonNumber}-${col.key}`} F
                                    type="button"
                                    status={status}
                                    disabled={!canTeacherTick}
                                    onClick={canTeacherTick ? () => handleToggle(lessonNumber, col.key) : undefined}
                                >
                                    {status === 0 ? "" : "✓"}
                                </CellButton>

                            );
                        })}
                    </TableRow>
                ))}
            </TableWrapper>
        </Section>
    );
};

export default ProgressChart;
